"use client"
/* */
import { jsx, jsxs } from 'react/jsx-runtime';
import 'react';
import '@tabler/icons-react';
import '../../../../../Icon/Icon.mjs';
import '../../../../../../lib/viewComponentContext/viewComponentContext.mjs';
import { IconFilter } from '../../../../../Icon/components/icons/IconFilter.mjs';
import TextView from '../../../../../../views/TextView.mjs';
import ButtonView from '../../../../../../views/ButtonView.mjs';
import { ContextMenu } from '../../../../../ContextMenu/ContextMenu.mjs';
import '../../../../../MenuItem/MenuItem.mjs';
import { ContextMenuTrigger } from '../../../../../ContextMenu/components/ContextMenuTrigger/ContextMenuTrigger.mjs';
import 'react-aria-components';
import '../../../../../ContextMenu/components/ContextMenuSection/ContextMenuSection.mjs';
import { FilterMenuItem } from './FilterMenuItem.mjs';
import headerStyles from '../../Header.module.css.mjs';

const FilterMenu = (props) => {
  const { filter } = props;
  const { values, mode, name, property } = filter;
  const filterItems = values.map((v) => /* @__PURE__ */ jsx(FilterMenuItem, { filterValue: v }, v.id));
  const activeFilterKeys = values.filter((v) => v.isActive).map((v) => v.id);
  return /* @__PURE__ */ jsxs(ContextMenuTrigger, { children: [
    /* @__PURE__ */ jsxs(
      ButtonView,
      {
        className: headerStyles.desktop,
        variant: "outline",
        color: "secondary",
        children: [
          /* @__PURE__ */ jsx(TextView, { children: name ?? property }),
          /* @__PURE__ */ jsx(IconFilter, {})
        ]
      }
    ),
    /* @__PURE__ */ jsx(
      ContextMenu,
      {
        selectionMode: mode === "one" ? "single" : "multiple",
        selectedKeys: activeFilterKeys,
        children: filterItems
      }
    )
  ] });
};

export { FilterMenu };
//# sourceMappingURL=FilterMenu.mjs.map
